jQuery(document).ready(function ($) {

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId == 106 || formId == 107) {

            $('#ccare__modal-cancel-btn').hide();
            $('#ccare__user-modal-cancel-btn').hide();
            $('#user-refresh-btn').trigger('click');
        }
    });

    $(document).on('gform_post_render', function (event, formId) {
        if (formId == 106 || formId == 107) {

            $('#ccare__modal-cancel-btn').show();
            $('#ccare__user-modal-cancel-btn').show();
        }
    });
});
